export default "/images/vendor/flag-icon-css/flags/4x3/bs.svg?527eff5cdc00fa23f06f9cd3596767df";